<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        Detalle orden de servicio /
        <router-link v-if="proviene === 'general'" to="/ordenes"
          ><a href="#">Regresar a ordenes de servicio</a>
        </router-link>
        <router-link v-else to="/ordenes/personal"
          ><a href="#">Regresar a ordenes de servicio</a>
        </router-link>
      </div>
      <div class="panel-body">
        <div class="col-md-12">
          <button
            class="btn btn-success"
            style="width: 20%"
            @click="generarImpresion()"
          >
            <i class="fa fa-print"></i> Imprimir
          </button>
          <h2 style="padding-top: 10px">
            ORDEN DE SERVICIO # {{ ordenId }}
          </h2>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <!-- <md-autocomplete :disabled="terminado && rol != 'ADMIN_MAIN' || (tecnicoId != usuarioId && rol != 'ADMIN_MAIN')" v-model="cliente" :md-options="clientesList" md-dense>
                            <label>Cliente</label>
                            </md-autocomplete> -->
                <md-autocomplete
                  :disabled="
                    (terminado && rol != 'ADMIN_MAIN') ||
                      (tecnicoId != usuarioId && rol != 'ADMIN_MAIN')
                  "
                  v-model="cliente"
                  :md-options="clientes"
                >
                  <label>Buscar cliente</label>
                  <template
                    slot="md-autocomplete-item"
                    slot-scope="{ item }"
                    >{{
                      `${item.cedula} _ ${item.nombre} ${
                        item.apellidos
                      }`
                    }}</template
                  >
                  <template slot="md-autocomplete-empty">
                    No se encontrarón datos
                  </template>
                </md-autocomplete>
              </div>
              <div class="form-group">
                <label>Síntoma</label>
                <textarea
                  autocomplete="on"
                  name="sintoma"
                  :disabled="
                    (terminado && rol != 'ADMIN_MAIN') ||
                      (tecnicoId != usuarioId && rol != 'ADMIN_MAIN')
                  "
                  v-model="sintoma"
                  class="form-control"
                  rows="4"
                ></textarea>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6">
                    <label>Marca</label>
                    <select
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      class="form-control"
                      v-model="marca"
                    >
                      <option
                        v-for="(option, index) in marcas"
                        :key="index"
                        v-bind:value="option.id"
                      >
                        {{ option.marca }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label>Equipo</label>
                    <select
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      class="form-control"
                      v-model="diagnostico"
                    >
                      <option
                        v-for="(e, i) in equipos"
                        v-bind:value="e.referencia"
                        >{{ e.referencia }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="form-group" v-if="diagnostico === 'Otro'">
                  <label>Otro</label>
                  <input
                    :disabled="
                      (terminado && rol != 'ADMIN_MAIN') ||
                        (tecnicoId != usuarioId &&
                          rol != 'ADMIN_MAIN')
                    "
                    class="form-control"
                    type="text"
                    v-model="otroDiagnostico"
                    placeholder="Ingrese el diagnóstico"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div
                    :class="
                      estado.estado === 'Pendiente'
                        ? 'col-md-4'
                        : 'col-md-6'
                    "
                  >
                    <label>Seleccione Estado</label>
                    <select
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      class="form-control"
                      v-model="estado.estado"
                      @change="reasignarEstado"
                    >
                      <option value="Aprobado">Aprobado</option>
                      <option value="Urgente">Urgente</option>
                      <option value="Pendiente">Pendiente</option>
                      <option value="No autorizado"
                        >No autorizado</option
                      >
                    </select>
                  </div>
                  <div
                    class="col-md-4"
                    v-if="estado.estado === 'Pendiente'"
                  >
                    <label>¿Qué está pendiente?</label>
                    <md-checkbox
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      @change="validarCheckboxEstado('autorizacion')"
                      v-model="estado.pendiente.autorizacion"
                      class="md-primary"
                      >Autorización</md-checkbox
                    >
                    <md-checkbox
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      @change="validarCheckboxEstado('repuesto')"
                      v-model="estado.pendiente.repuesto"
                      class="md-primary"
                      >Repuesto</md-checkbox
                    >
                    <md-checkbox
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      @change="validarCheckboxEstado('cotizacion')"
                      v-model="estado.pendiente.cotizacion"
                      class="md-primary"
                      >Cotización</md-checkbox
                    >
                  </div>
                  <div
                    :class="
                      estado.estado === 'Pendiente'
                        ? 'col-md-4'
                        : 'col-md-6'
                    "
                  >
                    <label>Seleccione Servicio</label>
                    <select
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      class="form-control"
                      v-model="servicio"
                    >
                      <option value="NINGUNO">NINGUNO</option>
                      <option value="Ajuste">Ajuste</option>
                      <option value="Garantia">Garantía</option>
                      <option value="Revision">Revisión</option>
                      <option value="venta">Venta</option>
                      <option value="Mantenimiento"
                        >Mantenimiento</option
                      >
                      <option value="Reparacion">Reparación</option>
                      <option value="No_tiene_reparacion"
                        >Nó tiene reparación</option
                      >
                      <option value="Analisis">Análisis</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Accesorios</label>
                <textarea
                  autocomplete="on"
                  name="accesorios"
                  :disabled="
                    (terminado && rol != 'ADMIN_MAIN') ||
                      (tecnicoId != usuarioId && rol != 'ADMIN_MAIN')
                  "
                  v-model="accesorios"
                  class="form-control"
                  rows="4"
                ></textarea>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-5">
                    <label>Precio</label>
                    <money
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      v-model="precio"
                      class="form-control"
                      :precision="0"
                    ></money>
                  </div>
                  <div class="col-md-7">
                    <md-autocomplete
                      :disabled="rol != 'ADMIN_MAIN'"
                      v-model="tecnico"
                      :md-options="tecnicosSelect"
                      md-dense
                    >
                      <label>Técnico asignado</label>
                    </md-autocomplete>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="panel panel-default">
                <div class="panel-heading dark-overlay">
                  <b>PROCESO</b>
                </div>
                <div class="panel-body">
                  <div class="form-group">
                    <label>PROCESO A REALIZAR</label>
                    <div class="row">
                      <div
                        :class="
                          this.proceso.proceso === 'Análisis'
                            ? 'col-md-4'
                            : 'col-md-6'
                        "
                      >
                        <select
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          class="form-control"
                          v-model="proceso.proceso"
                          @change="reasignarProceso"
                        >
                          <option value="seleccione" selected disabled
                            >Seleccione opción</option
                          >
                          <option
                            v-if="rol != 'ANALISTA'"
                            value="Ajuste"
                            >Ajuste</option
                          >
                          <option
                            v-if="rol != 'ANALISTA'"
                            value="Garantía"
                            >Garantía</option
                          >
                          <option
                            v-if="rol != 'ANALISTA'"
                            value="Revisión"
                            >Revisión</option
                          >
                          <option
                            v-if="rol != 'ANALISTA'"
                            value="Venta"
                            >Venta</option
                          >
                          <option
                            v-if="rol != 'ANALISTA'"
                            value="Mantenimiento"
                            >Mantenimiento</option
                          >
                          <option
                            v-if="rol != 'ANALISTA'"
                            value="Reparación"
                            >Reparación</option
                          >
                          <option value="No_tiene_reparacion"
                            >Nó tiene reparación</option
                          >
                          <option
                            v-if="
                              rol === 'ANALISTA' ||
                                rol === 'ADMIN_MAIN' ||
                                proceso.analisis.terminado
                            "
                            value="Análisis"
                            >Análisis</option
                          >
                        </select>
                      </div>
                      <div
                        :class="'col-md-4'"
                        v-if="proceso.proceso === 'Análisis'"
                      >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('aprobado')"
                          v-model="proceso.analisis.aprobado.aprobado"
                          class="md-primary"
                          >Aprobado</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('noaprobado')"
                          v-model="proceso.analisis.noaprobado"
                          class="md-primary"
                          >Nó aprobado</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('pendiente')"
                          v-model="
                            proceso.analisis.pendiente.pendiente
                          "
                          class="md-primary"
                          >Pendiente</md-checkbox
                        >
                        <!-- <md-checkbox :disabled="terminado && rol != 'ADMIN_MAIN' || (tecnicoId != usuarioId && rol != 'ADMIN_MAIN')" @change="validarCheckBox('terminado')" v-model="proceso.analisis.terminado" class="md-primary">Análisis terminado</md-checkbox> -->
                      </div>
                      <div
                        :class="'col-md-4'"
                        v-if="proceso.analisis.pendiente.pendiente"
                      >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('autorizacion')"
                          v-model="
                            proceso.analisis.pendiente.autorizacion
                          "
                          class="md-primary"
                          >Autorización</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('repuesto')"
                          v-model="
                            proceso.analisis.pendiente.repuesto
                          "
                          class="md-primary"
                          >Repuesto</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('venta')"
                          v-model="proceso.analisis.pendiente.venta"
                          class="md-primary"
                          >Venta</md-checkbox
                        >
                      </div>
                      <div
                        :class="'col-md-4'"
                        v-if="proceso.analisis.aprobado.aprobado"
                      >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('ajuste')"
                          v-model="proceso.analisis.aprobado.ajuste"
                          class="md-primary"
                          >Ajuste</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('mantenimiento')"
                          v-model="
                            proceso.analisis.aprobado.mantenimiento
                          "
                          class="md-primary"
                          >Mantenimiento</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('reparacion')"
                          v-model="
                            proceso.analisis.aprobado.reparacion
                          "
                          class="md-primary"
                          >Reparación</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('venta2')"
                          v-model="proceso.analisis.aprobado.venta"
                          class="md-primary"
                          >Venta</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('revision')"
                          v-model="proceso.analisis.aprobado.revision"
                          class="md-primary"
                          >Revisión</md-checkbox
                        >
                        <md-checkbox
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN') ||
                              (proceso.analisis.terminado &&
                                rol != 'ADMIN_MAIN')
                          "
                          @change="validarCheckBox('garantia')"
                          v-model="proceso.analisis.aprobado.garantia"
                          class="md-primary"
                          >Garantía</md-checkbox
                        >
                      </div>
                    </div>
                    <br />
                    <h4
                      style="color: black"
                      v-if="proceso.analisis.terminado"
                    >
                      FECHA FÍN ANÁLISIS: {{ proceso.analisis.fecha }}
                    </h4>
                  </div>

                  <div
                    class="form-group"
                    v-if="
                      proceso.analisis.terminado && rol != 'ANALISTA'
                    "
                  >
                    <div class="row">
                      <div class="col-md-6">
                        <label>Servicio realizado</label>
                        <select
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN')
                          "
                          class="form-control"
                          v-model="servicioRealizado"
                        >
                          <option value="NINGUNO">NINGUNO</option>
                          <option value="Ajuste">Ajuste</option>
                          <option value="Garantia">Garantía</option>
                          <option value="Revision">Revisión</option>
                          <option value="venta">Venta</option>
                          <option value="Mantenimiento"
                            >Mantenimiento</option
                          >
                          <option value="Reparacion"
                            >Reparación</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="proceso.proceso === 'Venta'"
                  >
                    <label>TARJETAS</label>
                    <md-table>
                      <md-table-row
                        v-if="ventaData && ventaData.length"
                      >
                        <md-table-head>Referencia</md-table-head>
                        <md-table-head>Bodega</md-table-head>
                        <md-table-head md-numeric
                          >Cantidad</md-table-head
                        >
                        <md-table-head></md-table-head>
                      </md-table-row>
                      <md-table-row
                        v-for="(tarjeta, index) in ventaData"
                        :key="index"
                      >
                        <md-table-cell
                          >{{ tarjeta.referencia }}
                        </md-table-cell>
                        <md-table-cell
                          >{{ tarjeta.bodega }}
                        </md-table-cell>
                        <md-table-cell md-numeric
                          >{{ tarjeta.cantidad }}
                          <i
                            :disabled="
                              (terminado && rol != 'ADMIN_MAIN') ||
                                (tecnicoId != usuarioId &&
                                  rol != 'ADMIN_MAIN')
                            "
                            @click="
                              (tarjeta.cantidad += 1),
                                agregarTarjetaBack(
                                  'quitar',
                                  tarjeta.id
                                )
                            "
                            style="color: green; cursor:pointer"
                            class="fa fa-plus"
                          ></i>
                        </md-table-cell>
                        <md-table-cell>
                          <i
                            :disabled="
                              (terminado && rol != 'ADMIN_MAIN') ||
                                (tecnicoId != usuarioId &&
                                  rol != 'ADMIN_MAIN')
                            "
                            @click="
                              (tarjeta.cantidad -= 1),
                                agregarTarjetaBack(
                                  'agregar',
                                  tarjeta.id
                                )
                            "
                            style="color: red; cursor:pointer"
                            class="fa fa-trash"
                          ></i>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                    <div class="row">
                      <div class="col-md-8">
                        <!-- <md-autocomplete :disabled="terminado && rol != 'ADMIN_MAIN' || (tecnicoId != usuarioId && rol != 'ADMIN_MAIN')" v-model="tarjeta" :md-options="tarjetasSelect" md-dense>
                                        <label>Tarjeta</label>
                                        </md-autocomplete> -->
                        <autocomplete
                          ref="autocompleteTarjetas"
                          :disableInput="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN')
                          "
                          placeholder="Selecciona la tarjeta"
                          :source="tarjetas"
                          input-class="form-control"
                          :results-display="
                            item => {
                              return `${item.id} - ${
                                item.referencia
                              } - ${item.bodega}`;
                            }
                          "
                          @selected="onSeletedTarjeta"
                          @clear="clearTarjeta"
                        >
                        </autocomplete>
                      </div>
                      <div class="col-md-4">
                        <button
                          :disabled="
                            (terminado && rol != 'ADMIN_MAIN') ||
                              (tecnicoId != usuarioId &&
                                rol != 'ADMIN_MAIN')
                          "
                          class="btn btn-success"
                          @click="agregarTarjeta()"
                        >
                          <i class="fa fa-plus"></i> Agregar tarjeta
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>REPUESTOS</label>
                    <md-table
                      v-if="repuestosData && repuestosData.length"
                    >
                      <md-table-row>
                        <md-table-head>Código</md-table-head>
                        <md-table-head>Referencia</md-table-head>
                        <md-table-head md-numeric
                          >Cantidad</md-table-head
                        >
                        <md-table-head></md-table-head>
                      </md-table-row>
                      <md-table-row
                        v-for="(repuesto, index) in repuestosData"
                        :key="index"
                      >
                        <md-table-cell
                          >{{ repuesto.codigo }}
                        </md-table-cell>
                        <md-table-cell
                          >{{ repuesto.referencia }}
                        </md-table-cell>
                        <md-table-cell md-numeric
                          >{{ repuesto.cantidad }}
                          <i
                            :disabled="
                              (terminado && rol != 'ADMIN_MAIN') ||
                                (tecnicoId != usuarioId &&
                                  rol != 'ADMIN_MAIN')
                            "
                            @click="
                              agregarRepuesto(
                                repuesto.referencia,
                                index
                              )
                            "
                            style="color: green; cursor:pointer"
                            class="fa fa-plus"
                          ></i>
                        </md-table-cell>
                        <md-table-cell>
                          <i
                            :disabled="
                              (terminado && rol != 'ADMIN_MAIN') ||
                                (tecnicoId != usuarioId &&
                                  rol != 'ADMIN_MAIN')
                            "
                            @click="eliminarRepuesto(index)"
                            style="color: red; cursor:pointer"
                            class="fa fa-trash"
                          ></i>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                  <div class="row">
                    <div class="col-md-8">
                      <!-- <md-autocomplete :disabled="terminado && rol != 'ADMIN_MAIN' || (tecnicoId != usuarioId && rol != 'ADMIN_MAIN')" v-model="repuesto" :md-options="repuestosSelect" md-dense>
                                        <label>Repuesto</label>
                                        </md-autocomplete> -->
                      <autocomplete
                        ref="autocompleteRepuestos"
                        :disableInput="
                          (terminado && rol != 'ADMIN_MAIN') ||
                            (tecnicoId != usuarioId &&
                              rol != 'ADMIN_MAIN')
                        "
                        placeholder="Selecciona el repuesto"
                        :source="repuestos"
                        input-class="form-control"
                        :results-display="
                          item => {
                            return `${item.codigo}_${
                              item.referencia
                            }`;
                          }
                        "
                        @selected="onSeletedRepuesto"
                        @clear="clearRepuesto"
                      >
                      </autocomplete>
                    </div>
                    <div class="col-md-4">
                      <button
                        :disabled="
                          (terminado && rol != 'ADMIN_MAIN') ||
                            (tecnicoId != usuarioId &&
                              rol != 'ADMIN_MAIN')
                        "
                        class="btn btn-success"
                        @click="agregarRepuesto(null, 0)"
                      >
                        <i class="fa fa-plus"></i> Agregar repuesto
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>CONTÁCTO CLIENTE</label>
                  <div class="row">
                    <div class="col-md-4">
                      <md-switch
                        :disabled="
                          (terminado && rol != 'ADMIN_MAIN') ||
                            (tecnicoId != usuarioId &&
                              rol != 'ADMIN_MAIN')
                        "
                        @change="validarCheckBox('presencial')"
                        v-model="contactoCliente.presencial"
                        class="md-primary"
                        >Presencial</md-switch
                      >
                    </div>
                    <div class="col-md-4">
                      <md-switch
                        :disabled="
                          (terminado && rol != 'ADMIN_MAIN') ||
                            (tecnicoId != usuarioId &&
                              rol != 'ADMIN_MAIN')
                        "
                        @change="validarCheckBox('llamada')"
                        v-model="contactoCliente.llamada"
                        class="md-primary"
                        >Llamada</md-switch
                      >
                    </div>
                    <div class="col-md-4">
                      <md-switch
                        :disabled="
                          (terminado && rol != 'ADMIN_MAIN') ||
                            (tecnicoId != usuarioId &&
                              rol != 'ADMIN_MAIN')
                        "
                        @change="validarCheckBox('mensaje')"
                        v-model="contactoCliente.mensaje"
                        class="md-primary"
                        >Mensaje</md-switch
                      >
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="
                      contactoCliente.presencial ||
                        contactoCliente.llamada ||
                        contactoCliente.mensaje
                    "
                  >
                    <label>Observaciones del contácto</label>
                    <textarea
                      :disabled="
                        (terminado && rol != 'ADMIN_MAIN') ||
                          (tecnicoId != usuarioId &&
                            rol != 'ADMIN_MAIN')
                      "
                      v-model="contactoCliente.observacion"
                      class="form-control"
                      rows="2"
                    ></textarea>
                  </div>
                </div>
                <div class="form-group">
                  <label>OBSERVACIONES INTERNAS</label>
                  <textarea
                    autocomplete="on"
                    name="observaciones"
                    :disabled="
                      (terminado && rol != 'ADMIN_MAIN') ||
                        (tecnicoId != usuarioId &&
                          rol != 'ADMIN_MAIN')
                    "
                    v-model="observaciones"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label>RECOMENDACIONES CLIENTE</label>
                  <textarea
                    autocomplete="on"
                    name="recomendaciones"
                    :disabled="
                      (terminado && rol != 'ADMIN_MAIN') ||
                        (tecnicoId != usuarioId &&
                          rol != 'ADMIN_MAIN')
                    "
                    v-model="recomendaciones"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
                <div
                  class="form-group"
                  v-if="
                    proceso.proceso === 'Análisis' ||
                      proceso.proceso === 'No_tiene_reparacion'
                  "
                >
                  <div class="row">
                    <div class="col-md-12">
                      <md-switch
                        @change="terminarAnalisis"
                        :disabled="
                          (terminado && rol != 'ADMIN_MAIN') ||
                            (tecnicoId != usuarioId &&
                              rol != 'ADMIN_MAIN') ||
                            (proceso.analisis.terminado &&
                              rol != 'ADMIN_MAIN')
                        "
                        v-if="!proceso.analisis.terminado"
                        v-model="proceso.analisis.terminado"
                        class="md-primary"
                        >Análisis sin terminar</md-switch
                      >
                      <md-switch
                        @change="terminarAnalisis"
                        :disabled="
                          (terminado && rol != 'ADMIN_MAIN') ||
                            (tecnicoId != usuarioId &&
                              rol != 'ADMIN_MAIN') ||
                            (proceso.analisis.terminado &&
                              rol != 'ADMIN_MAIN')
                        "
                        v-else
                        v-model="proceso.analisis.terminado"
                        class="md-primary"
                        >Análisis terminado</md-switch
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group" v-if="rol != 'ANALISTA'">
                  <md-switch
                    :disabled="
                      (terminado && rol != 'ADMIN_MAIN') ||
                        (tecnicoId != usuarioId &&
                          rol != 'ADMIN_MAIN')
                    "
                    v-if="!terminarProceso"
                    v-model="terminarProceso"
                    class="md-primary"
                    >Proceso sin terminar</md-switch
                  >
                  <md-switch
                    :disabled="
                      (terminado && rol != 'ADMIN_MAIN') ||
                        (tecnicoId != usuarioId &&
                          rol != 'ADMIN_MAIN')
                    "
                    v-else
                    v-model="terminarProceso"
                    class="md-primary"
                    >Proceso terminado</md-switch
                  >
                </div>
              </div>

              <button
                v-if="rol != 'ANALISTA'"
                :disabled="
                  (terminado && rol != 'ADMIN_MAIN') ||
                    (tecnicoId != usuarioId && rol != 'ADMIN_MAIN')
                "
                @click="checkForm"
                style="width: 100%;"
                class="btn btn-primary"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>

        <div hidden class="col-md-6" id="impresion">
          <div
            class="texto"
            style="margin: auto;padding: 15px;border: 0;background: white;max-width: 700px;width: 90%;color: #82899A;"
          >
            <table
              width="100%"
              style="margin: 0;padding: 0;border: 0;"
            >
              <tr style="margin: 0;padding: 0;border: 0;">
                <h1>SOLUCASA</h1>
              </tr>
              <tr style="margin: 0;padding: 0;border: 0;">
                <td style="margin: 0;padding: 0;border: 0;">
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Régimen no responsable de IVA.</b>
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>NIT. 42.775.833-7</b>
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Cra 53 # 61-15, Medellín</b>
                  </p>

                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Tel. 604 4734651 - Móvil 324 454 0402</b>
                  </p>
                  <br />
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Fecha: {{ getFecha() }}</b>
                  </p>
                  <br />
                  <h4
                    style="margin: 0;padding: 0;border: 0; font-size: 22px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>{{ `${cliente.split('_')[1]}` }}</b>
                  </h4>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 20px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Orden de servicio N°</b> {{ ordenId }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Síntoma: </b>{{ sintoma }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Marca: </b
                    >{{
                      marcas.length > 0
                        ? marcas.filter(m => m.id === marca)[0].marca
                        : ''
                    }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Equipo: </b>{{ diagnostico }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Estado: </b>{{ estado.estado }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Servicio: </b>{{ servicio }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Accesorios: </b>{{ accesorios }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                    v-if="precio || precio > 0"
                  >
                    <b>Precio: </b>{{ precio | currency }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Recomendaciones: </b
                    >{{
                      recomendaciones
                        ? recomendaciones
                        : 'Sin recomendaciones'
                    }}
                  </p>
                  <!-- <p style="margin: 0;padding: 0;border: 0;" v-if="observaciones != ''"><b>Observaciones: </b>{{observaciones}}</p> -->
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                    v-if="
                      servicio === 'Venta' ||
                        servicio === 'Reparacion'
                    "
                  >
                    <b>Garantía: </b
                    >{{
                      servicio === 'Venta'
                        ? '1 Mes'
                        : servicio === 'Reparacion'
                        ? '1 Mes'
                        : ''
                    }}
                  </p>
                  <p
                    style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                  >
                    <b>Nota:</b> Si pasados 3 meses su producto no ha
                    sido retirado, solucasa dispondrá de este. (Ley
                    1480 de 2011). Las garantías se cubren de acuerdo
                    al daño reparado.
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import { Money } from 'v-money';
import { mapState } from 'vuex';
import Moment from 'moment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Autocomplete from 'vuejs-auto-complete';
export default {
  name: 'editar-orden',
  components: {
    Loading,
    Money,
    Autocomplete,
  },
  props: {
    ordenId: Number,
    proviene: String,
  },
  computed: mapState(['usuario', 'rol', 'usuarioId']),
  data() {
    return {
      loading: true,
      otroDiagnostico: '',
      clientes: [],
      clientesList: [],
      cliente: '',
      sintoma: '',
      marca: 100,
      marcas: [],
      tarjetas: [],
      tarjetasSelect: [],
      tarjeta: '',
      terminado: false,
      terminarProceso: false,
      diagnostico: 'NINGUNO',
      repuesto: null,
      observaciones: '',
      recomendaciones: '',
      estado: {
        estado: '',
        pendiente: {
          autorizacion: false,
          repuesto: false,
          cotizacion: false,
        },
      },
      estadoCopy: {},
      proceso: {
        proceso: 'seleccione',
        analisis: {
          aprobado: {
            aprobado: false,
            ajuste: false,
            mantenimiento: false,
            reparacion: false,
            venta: false,
            revision: false,
            garantia: false,
          },
          terminado: false,
          fecha: '',
          noaprobado: false,
          pendiente: {
            pendiente: false,
            autorizacion: false,
            repuesto: false,
            venta: false,
          },
        },
      },
      contactoCliente: {
        presencial: false,
        llamada: false,
        mensaje: false,
        observacion: '',
      },
      servicio: 'Ajuste',
      servicioRealizado: 'NINGUNO',
      accesorios: '',
      precio: 0,
      tecnico: '',
      tecnicoId: '',
      tecnicos: [],
      tecnicosSelect: [],
      repuestos: [],
      repuestosSelect: [],
      repuestosData: [],
      ventaData: [],
      equipos: [],
    };
  },
  watch: {
    cliente() {
      if (this.cliente.length > 0) {
        this.getClientes();
      } else {
        this.clientesList = [];
      }
    },
  },
  async created() {
    this.getUsers();
    this.getRepuestos();
    this.getTarjetas();
    this.getEquipos();
    // this.getClientes()
    this.ordenId = this.$router.history.current.params.ordenId;
    this.proviene = this.$router.history.current.params.proviene;
    let data = {
      ordenId: this.ordenId,
    };
    ServiceApi.post('/ordenes/detail', data)
      .then(response => {
        let data = response.data.data;
        // console.log('DATA::::', response.data)
        this.marcas = response.data.marcas;
        this.marca = 100;
        this.ordenId = data.id;
        this.cliente = data.cliente.fullname;
        this.sintoma = data.sintoma;
        this.marca = data.marca_id;
        this.diagnostico = data.diagnostico;
        this.otroDiagnostico =
          this.diagnostico === 'Otro' ? data.diagnostico : '';
        this.estado = JSON.parse(data.estado);
        this.estadoCopy = JSON.parse(data.estado);
        this.servicio = data.servicio;
        this.accesorios = data.accesorios;
        this.precio = data.precio;
        this.tecnicoId = data.tecnico.id;
        this.recomendaciones = data.recomendaciones;
        this.tecnico = data.tecnico.fullname;
        this.servicioRealizado = data.servicio_realizado
          ? data.servicio_realizado
          : 'NINGUNO';
        if (data.proceso) {
          this.proceso = JSON.parse(data.proceso);
          if (this.proceso.proceso === 'Venta') {
            this.ventaData = this.proceso.venta;
          }
        }
        if (data.repuestos) {
          this.repuestosData = JSON.parse(data.repuestos);
        }
        if (data.contacto_cliente) {
          this.contactoCliente = JSON.parse(data.contacto_cliente);
        }
        this.observaciones = data.observaciones || '';
        if (data.terminado) {
          this.terminado = data.terminado === 1 ? true : false;
          this.terminarProceso = data.terminado === 1 ? true : false;
        }
        this.loading = false;
      })
      .catch(err => {
        this.$router.push('/ordenes');
        this.loading = false;
      });
  },
  mounted() {},
  methods: {
    getEquipos() {
      ServiceApi.get('/tarjetas/list')
        .then(response => {
          this.equipos = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onSeletedRepuesto(item) {
      this.repuesto = item.selectedObject;
    },
    clearRepuesto() {
      this.repuesto = null;
    },
    onSeletedTarjeta(item) {
      this.tarjeta = item.selectedObject;
    },
    clearTarjeta() {
      this.tarjeta = null;
    },
    validarExistenciaRepuesto(repuesto) {
      if (repuesto.cantidad < 1) {
        this.$noty.error(
          'El repuesto seleccionado no tiene la suficiente cantidad para poder ser asignado'
        );
        return false;
      } else {
        return true;
      }
    },
    agregarRepuesto(id, pos = null) {
      if (id === null && !this.terminado) {
        if (!this.repuesto) {
          this.$noty.warning('Debe escoger un repuesto');
        } else {
          let codigo = this.repuesto.codigo;
          let repuesto = this.repuestos.filter(
            r => r.codigo === codigo.trim()
          )[0];
          let existe = this.repuestosData.filter(
            r => r.idRepuesto === repuesto.id
          )[0];
          if (existe) {
            let cantidad = existe.cantidad + 1;
            if (cantidad <= repuesto.cantidad) {
              this.repuestosData[pos].cantidad = existe.cantidad + 1;
              this.modificarRepuestoBack('borrar', repuesto.id, 1);
            } else {
              this.$noty.error(
                'El repuesto seleccionado no tiene la suficiente cantidad para poder ser asignado'
              );
            }
          } else {
            // console.log('EL CODIGO:::', codigo)
            // console.log('EL REPUESTO::::', repuesto)
            if (this.validarExistenciaRepuesto(repuesto)) {
              this.repuestosData.push({
                idRepuesto: repuesto.id,
                codigo: repuesto.codigo,
                referencia: repuesto.referencia,
                cantidad: 1,
              });
              this.modificarRepuestoBack('borrar', repuesto.id, 1);
            }
          }
        }
      } else {
        if (!this.terminado) {
          let repuesto = this.repuestos.filter(
            r => r.referencia === id
          )[0];
          let cantidad = this.repuestosData[pos].cantidad + 1;
          if (cantidad <= repuesto.cantidad) {
            this.repuestosData[pos].cantidad++;
            this.repuesto = '';
            this.modificarRepuestoBack('borrar', repuesto.id, 1);
          } else {
            this.$noty.error(
              'El repuesto seleccionado no tiene la suficiente cantidad para poder ser asignado'
            );
          }
        }
      }
    },
    agregarTarjeta(idTarjeta = null, pos = null) {
      if (!this.tarjeta && pos === null) {
        this.$noty.warning('Debe escoger una tarjeta');
      } else {
        let id = idTarjeta ? idTarjeta : this.tarjeta.id;
        this.modificarTarjetaBack('quitar', id);
      }
    },
    modificarRepuestoBack(accion, repuestoId, cantidad) {
      let data = {
        repuestoId: repuestoId,
        cantidad: cantidad,
      };
      ServiceApi.post(`/repuesto/${accion}`, data)
        .then(response => {
          this.saveInformation(true);
        })
        .catch(err => {});
    },
    agregarTarjetaBack(accion, tarjetaId) {
      let data = {
        tarjetaId,
      };
      ServiceApi.post(`/tarjetas/${accion}`, data)
        .then(response => {
          let tarjeta = this.ventaData.filter(
            t => t.id === tarjetaId
          )[0];
          if (tarjeta.cantidad === 0) {
            let newData = this.ventaData.filter(
              t => t.id != tarjeta.id
            );
            this.ventaData = newData;
          }
          this.saveInformation(true);
        })
        .catch(err => {});
    },
    modificarTarjetaBack(accion, tarjetaId) {
      let data = {
        tarjetaId,
      };
      ServiceApi.post(`/tarjetas/${accion}`, data)
        .then(response => {
          let tarjeta = response.data.data;
          if (accion === 'quitar') {
            if (this.ventaData && this.ventaData.length > 0) {
              if (
                this.ventaData.filter(t => t.id === tarjeta.id)
                  .length > 0
              ) {
                this.ventaData.filter(
                  t => t.id === tarjeta.id
                )[0].cantidad += 1;
              } else {
                tarjeta.cantidad = 1;
                this.ventaData.push(tarjeta);
              }
            } else {
              tarjeta.cantidad = 1;
              this.ventaData.push(tarjeta);
            }
          } else {
            if (
              this.ventaData.filter(t => t.id === tarjeta.id)[0]
                .cantidad === 0
            ) {
              this.ventaData.forEach((item, key) => {
                item.id === tarjeta.id
                  ? this.ventaData.splice(key, 1)
                  : '';
              });
            }
          }
          this.saveInformation(true);
        })
        .catch(err => {
          // console.log('AQUI::::', err)
        });
    },
    eliminarRepuesto(index) {
      if (!this.terminado) {
        let repuesto = this.repuestosData[index];
        if (repuesto.cantidad > 1) {
          this.repuestosData[index].cantidad = repuesto.cantidad - 1;
        } else {
          this.repuestosData.splice(index, 1);
        }
        this.modificarRepuestoBack('agregar', repuesto.idRepuesto, 1);
      }
    },
    checkForm() {
      if (!this.cliente) {
        this.$noty.error('Debe asignar la orden a un cliente');
      } else if (!this.sintoma) {
        this.$noty.error('El síntoma es requerido');
      } else if (!this.marca) {
        this.$noty.error('La marca es requerida');
      } else if (!this.diagnostico) {
        this.$noty.error('El diagnóstico es requerido');
      } else if (!this.estado) {
        this.$noty.error('El estado es requerido');
      } else if (!this.servicio) {
        this.$noty.error('El servicio es requerido');
      } else if (!this.accesorios) {
        this.$noty.error('El campo accesorios es requerido');
      } else if (
        this.servicio != 'Garantia' &&
        this.servicio != 'No_tiene_reparacion'
      ) {
        if (this.proceso.proceso === 'No_tiene_reparacion') {
          this.saveInformation(false);
        } else {
          if (this.terminarProceso && this.precio === 0) {
            this.$noty.error(
              'Debe asignar un precio para poder terminar la orden de servicio'
            );
          } else {
            this.saveInformation(false);
          }
        }
      } else {
        this.saveInformation(false);
      }
    },
    reasignarEstado() {
      if (this.estado.estado != 'Pendiente') {
        this.estado.pendiente.autorizacion = false;
        this.estado.pendiente.repuesto = false;
        this.estado.pendiente.venta = false;
      }
    },
    validarCheckBox(value) {
      switch (value) {
        case 'terminado':
          if (this.proceso.analisis.terminado) {
            this.proceso.analisis.noaprobado = false;
            this.proceso.analisis.pendiente.pendiente = false;
            this.proceso.analisis.pendiente.aprobado = false;
          }
        case 'aprobado':
          if (this.proceso.analisis.aprobado.aprobado) {
            this.estado = this.estadoCopy;
            this.proceso.analisis.noaprobado = false;
            this.proceso.analisis.pendiente.pendiente = false;
            this.proceso.analisis.terminado = false;
            this.proceso.analisis.pendiente.repuesto = false;
            this.proceso.analisis.pendiente.venta = false;
            this.proceso.analisis.pendiente.autorizacion = false;
          }
          break;
        case 'noaprobado':
          if (this.proceso.analisis.noaprobado) {
            this.estado = this.estadoCopy;
            this.proceso.analisis.pendiente.pendiente = false;
            this.proceso.analisis.aprobado.aprobado = false;
            this.proceso.analisis.terminado = false;
            this.proceso.analisis.pendiente.repuesto = false;
            this.proceso.analisis.pendiente.venta = false;
            this.proceso.analisis.pendiente.autorizacion = false;
          }
          break;
        case 'pendiente':
          if (this.proceso.analisis.pendiente.pendiente) {
            this.estado.estado = 'Pendiente';
            this.proceso.analisis.aprobado.aprobado = false;
            this.proceso.analisis.noaprobado = false;
            this.proceso.analisis.terminado = false;
          }
          break;
        case 'autorizacion':
          if (this.proceso.analisis.pendiente.autorizacion) {
            this.estado.pendiente.autorizacion = true;
            this.estado.pendiente.repuesto = false;
            this.estado.pendiente.cotizacion = false;
            this.proceso.analisis.pendiente.repuesto = false;
            this.proceso.analisis.pendiente.venta = false;
          }
          break;
        case 'repuesto':
          if (this.proceso.analisis.pendiente.repuesto) {
            this.estado.pendiente.repuesto = true;
            this.estado.pendiente.autorizacion = false;
            this.estado.pendiente.cotizacion = false;
            this.proceso.analisis.pendiente.autorizacion = false;
            this.proceso.analisis.pendiente.venta = false;
          }
          break;
        case 'venta':
          if (this.proceso.analisis.pendiente.venta) {
            this.estado.pendiente.cotizacion = true;
            this.estado.pendiente.repuesto = false;
            this.estado.pendiente.autorizacion = false;
            this.proceso.analisis.pendiente.autorizacion = false;
            this.proceso.analisis.pendiente.repuesto = false;
          }
          break;
        case 'ajuste':
          if (this.proceso.analisis.aprobado.ajuste) {
            this.proceso.analisis.aprobado.mantenimiento = false;
            this.proceso.analisis.aprobado.reparacion = false;
            this.proceso.analisis.aprobado.venta = false;
            this.proceso.analisis.aprobado.revision = false;
            this.proceso.analisis.aprobado.garantia = false;
          }
          break;
        case 'mantenimiento':
          if (this.proceso.analisis.aprobado.mantenimiento) {
            this.proceso.analisis.aprobado.ajuste = false;
            this.proceso.analisis.aprobado.reparacion = false;
            this.proceso.analisis.aprobado.venta = false;
            this.proceso.analisis.aprobado.revision = false;
            this.proceso.analisis.aprobado.garantia = false;
          }
          break;
        case 'reparacion':
          if (this.proceso.analisis.aprobado.reparacion) {
            this.proceso.analisis.aprobado.ajuste = false;
            this.proceso.analisis.aprobado.mantenimiento = false;
            this.proceso.analisis.aprobado.venta = false;
            this.proceso.analisis.aprobado.revision = false;
            this.proceso.analisis.aprobado.garantia = false;
          }
          break;
        case 'venta2':
          if (this.proceso.analisis.aprobado.venta) {
            this.proceso.analisis.aprobado.ajuste = false;
            this.proceso.analisis.aprobado.mantenimiento = false;
            this.proceso.analisis.aprobado.reparacion = false;
            this.proceso.analisis.aprobado.revision = false;
            this.proceso.analisis.aprobado.garantia = false;
          }
          break;
        case 'revision':
          if (this.proceso.analisis.aprobado.revision) {
            this.proceso.analisis.aprobado.ajuste = false;
            this.proceso.analisis.aprobado.mantenimiento = false;
            this.proceso.analisis.aprobado.reparacion = false;
            this.proceso.analisis.aprobado.venta = false;
            this.proceso.analisis.aprobado.garantia = false;
          }
          break;
        case 'garantia':
          if (this.proceso.analisis.aprobado.garantia) {
            this.proceso.analisis.aprobado.ajuste = false;
            this.proceso.analisis.aprobado.mantenimiento = false;
            this.proceso.analisis.aprobado.reparacion = false;
            this.proceso.analisis.aprobado.venta = false;
            this.proceso.analisis.aprobado.revision = false;
          }
          break;
        case 'presencial':
          if (this.contactoCliente.presencial) {
            this.contactoCliente.llamada = false;
            this.contactoCliente.mensaje = false;
          }
          break;
        case 'llamada':
          if (this.contactoCliente.llamada) {
            this.contactoCliente.presencial = false;
            this.contactoCliente.mensaje = false;
          }
          break;
        case 'mensaje':
          if (this.contactoCliente.mensaje) {
            this.contactoCliente.presencial = false;
            this.contactoCliente.llamada = false;
          }
          break;
      }
    },
    validarCheckboxEstado(value) {
      switch (value) {
        case 'autorizacion':
          if (this.estado.pendiente.autorizacion) {
            this.estado.pendiente.repuesto = false;
            this.estado.pendiente.cotizacion = false;
          }
          break;
        case 'repuesto':
          if (this.estado.pendiente.repuesto) {
            this.estado.pendiente.autorizacion = false;
            this.estado.pendiente.cotizacion = false;
          }
          break;
        case 'cotizacion':
          if (this.estado.pendiente.cotizacion) {
            this.estado.pendiente.repuesto = false;
            this.estado.pendiente.autorizacion = false;
          }
          break;
      }
    },
    reasignarProceso() {
      if (this.proceso.proceso != 'Análisis') {
        this.proceso.analisis = {
          aprobado: {
            aprobado: false,
            ajuste: false,
            mantenimiento: false,
            reparacion: false,
            venta: false,
            revision: false,
            garantia: false,
          },
          noaprobado: false,
          pendiente: {
            pendiente: false,
            autorizacion: false,
            repuesto: false,
            venta: false,
          },
        };
      }
    },
    terminarAnalisis() {
      if (this.proceso.analisis.terminado) {
        let data = {
          ordenId: this.ordenId,
          proceso: this.proceso,
          userId: this.usuarioId,
          estado: this.estado,
          fecha: Moment().format('MM/DD/YYYY, h:mm:ss a'),
          sintoma: this.sintoma,
          marcaId: this.marca,
          diagnostico: this.diagnostico,
          servicio: this.servicio,
          accesorios: this.accesorios,
          precio: this.precio,
          repuestos: this.repuestosData,
          contactoCliente: this.contactoCliente,
          observaciones: this.observaciones,
          terminado: this.terminarProceso,
          recomendacion: this.recomendaciones,
          servicioRealizado: this.proceso.analisis.terminado
            ? this.servicioRealizado
            : null,
          userId: this.usuarioId,
        };
        this.loading = true;
        ServiceApi.post('/orden/terminarAnalisis', data)
          .then(response => {
            if (response.data.status) {
              this.$store.dispatch('validateSessionUser', []);
              this.loading = false;
              let alertas = response.data.data.alertas;
              // console.log('RESPUESTA::::', response.data)
              alertas.forEach((alerta, key) => {
                this.$ws.$emitToServer(`ALERTS`, 'alert', { alerta });
              });
              Swal.fire({
                type: 'success',
                title: `Orden de servicio # ${
                  this.ordenId
                } actualizada con éxito`,
                showConfirmButton: true,
                timer: 5000,
              });
              this.$router.push('/ordenes');
            }
          })
          .catch(err => {
            console.log('EL ERROR:::', err);
            this.loading = false;
          });
      }
    },
    async saveInformation(repuesto) {
      let fecha = Moment().format('YYYY/MM/DD h:mm:ss');
      this.loading = true;
      this.proceso.venta = this.ventaData;
      let cedula = this.cliente.split('_')[0];
      let data = {
        clienteCedula: cedula.trim(),
        ordenId: this.ordenId,
        sintoma: this.sintoma,
        marcaId: this.marca,
        diagnostico: this.diagnostico,
        estado: this.estado,
        servicio: this.servicio,
        accesorios: this.accesorios,
        precio: this.precio,
        tecnicoId: parseInt(this.tecnico.split('-')[0]),
        proceso: this.proceso,
        repuestos: this.repuestosData,
        contactoCliente: this.contactoCliente,
        observaciones: this.observaciones,
        terminado: this.terminarProceso,
        recomendacion: this.recomendaciones,
        servicioRealizado: this.proceso.analisis.terminado
          ? this.servicioRealizado
          : null,
        userId: this.usuarioId,
        fecha: fecha,
      };
      // console.log('LA DATA::::', data)
      ServiceApi.post('/ordenes/update', data)
        .then(response => {
          if (response.data.status) {
            this.loading = false;
            if (!repuesto) {
              // this.$noty.success('Orden de servicio modificada con éxito')
              let alerta = response.data.alerta;
              let tecnicoAsignado = `${
                response.data.tecnicoAsignado.nombre
              } ${response.data.tecnicoAsignado.apellidos}`;
              if (alerta) {
                this.$ws.$emitToServer(`ALERTS`, 'alert', { alerta });
              }
              Swal.fire({
                type: 'success',
                title: `Orden de servicio # ${
                  this.ordenId
                } Técnico: ${tecnicoAsignado}`,
                showConfirmButton: true,
                timer: 15000,
              });
              this.$store.dispatch('validateSessionUser', []);
              this.$router.push(
                `${
                  this.proviene == 'general'
                    ? '/ordenes'
                    : '/ordenes/personal'
                }`
              );
            }
          }
        })
        .catch(err => {
          console.log('EL ERROR:::', err);
          this.loading = false;
          this.$noty.error(
            'Ocurrio un error al editar la orden de servicio, intente nuevamente o contacte el administrador'
          );
        });
    },
    onCancel() {},
    getClientes() {
      this.clientesList = [];
      this.loading = true;
      let data = {
        filter: this.cliente,
      };
      ServiceApi.post('/cliente/listSinPaginacion', data)
        .then(response => {
          let data = response.data.data;
          this.clientes = data;
          this.loading = false;
          // this.setClienteList()
        })
        .catch(err => {
          //this.$noty.error('Ocurrio un error al consultar los clientes')
          this.loading = false;
          this.$router.push('/ordenes');
        });
    },
    setClienteList() {
      this.loading = true;
      this.clientes.map((item, key) => {
        this.clientesList.push(
          `${item.cedula} _ ${item.nombre} ${item.apellidos}`
        );
      });
      this.loading = false;
    },
    validateDiagnostico(diagnostico) {
      switch (diagnostico) {
        case 'Cto.Fuente':
          return 'Cto.Fuente';
          break;
        case 'Cto.Control':
          return 'Cto.Control';
          break;
        case 'Cto.Potencia':
          return 'Cto.Potencia';
          break;
        case 'No identificado':
          return 'No identificado';
          break;
        case 'Funcionamiento normal':
          return 'Funcionamiento normal';
          break;
        default:
          return 'Otro';
          break;
      }
    },
    getUsers() {
      this.loading = true;
      ServiceApi.get('/user/list')
        .then(response => {
          // console.log('USERS:::', response)
          let data = response.data.data.filter(
            t => t.rol != 'ADMIN_MAIN'
          );
          this.tecnicos = data;
          this.tecnicosSelect = data.map((element, key) => {
            return (
              element.id +
              ' - ' +
              element.nombre +
              ' ' +
              element.apellidos
            );
          });

          this.loading = false;
        })
        .catch(err => {
          // this.$noty.error('Ocurrio un error al consultar los usuarios')
          this.loading = false;
          this.$router.push('/ordenes');
        });
    },
    getRepuestos() {
      this.loading = true;
      ServiceApi.get('/repuesto/list')
        .then(response => {
          // console.log('RESPUESTOS:::', response)
          let data = response.data.data;
          this.repuestos = data.reverse();
          if (!data.length) {
            // this.$noty.warning('Debe crear primero los repuestos')
            // this.$router.push('/repuestos/crear')
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          // this.$router.push('/ordenes')
        });
    },
    getTarjetas() {
      this.loading = true;
      ServiceApi.get('/tarjetas/list')
        .then(response => {
          // console.log('TARJETAS:::', response)
          let data = response.data.data;
          this.tarjetas = data.length > 0 ? data.reverse() : [];
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar las tarjetas'
          );
          this.loading = false;
          // this.$router.push('/')
        });
    },
    generarImpresion() {
      let element = document.getElementById('impresion');
      var ventana = window.open('', 'PRINT', 'height=500,width=700');
      ventana.document.write(
        '<html><head><title>' + 'SOLUCASA' + '</title>'
      );
      ventana.document.write('</head><body >');
      ventana.document.write(element.innerHTML);
      ventana.document.write('</body></html>');
      ventana.document.close();
      ventana.focus();
      ventana.print();
      ventana.close();
      return true;
    },
    getFecha() {
      return Moment().format('YYYY/MM/DD h:mm:ss');
    },
  },
};
</script>
